/**
 * Modo ao vivo (rota.vuckobrand.com): o login e as Automações falam com o servidor real
 * (`apps/server/src/panel.ts`); o Painel e o Estúdio seguem na simulação, com um aviso discreto.
 *
 * Liga com o build `VITE_ROTA_LIVE=true` ou, para testar, com `?provider=api` na URL. A decisão é
 * tomada uma vez por aba (na primeira leitura): a navegação interna tira a query da URL e o modo
 * não pode mudar no meio do caminho.
 */

let cached: boolean | null = null;

export function liveModeFrom(env: string | boolean | undefined, search: string): boolean {
  if (env === true || env === 'true' || env === '1') return true;
  return new URLSearchParams(search).get('provider') === 'api';
}

export function isLiveMode(): boolean {
  cached ??= liveModeFrom(
    import.meta.env.VITE_ROTA_LIVE as string | undefined,
    typeof location === 'undefined' ? '' : location.search,
  );
  return cached;
}

/** Só nos testes: força (ou limpa, com `null`) o modo. */
export function setLiveModeForTests(v: boolean | null): void {
  cached = v;
}
